import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useRequests } from '../../../../redux/reducer/requests';
import Back from '../../../features/back/Back';
import { ratingScrollbarSettings, shopContent } from '../../../../constants/copyright';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Scrollbar } from 'react-scrollbars-custom';
import { useContent, useProducts } from '../../../../redux/reducer/content';
import { useClothType } from '../../../../hooks/useClothType';
import { useUser } from '../../../../redux/reducer/user';
import { stores, defaultStore } from '../../../../translations';
const { toggle: toggleData } = shopContent;
import ShopHeader from '../shopHeader/ShopHeader';
import ShopInfo from '../shopInfo/ShopInfo';
import ShopItems from '../shopItems/ShopItems';

const Shop = React.forwardRef(function Shop({ callbacks }, ref) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { shopItems, notFilteredShopItems } = useContent();
  const { buyProducts } = useProducts();
  const {
    profile: { items },
  } = useUser();
  const [shopState, setShopState] = useState(Object.keys(shopItems)[0]);
  const getSlotType = useClothType();

  const necessaryItems = useMemo(
    () =>
      notFilteredShopItems.reduce((acc, itemData) => {
        const { id, product_id } = itemData;

        const condition = getSlotType(id) === shopState && typeof product_id === 'number';

        if (!condition) return acc;

        const product = buyProducts?.find(({ id }) => id === product_id);

        const profileItem = items?.find(({ id: itemId }) => itemId === id);

        const status = !profileItem ? 'absent' : profileItem?.is_equipped ? 'equipped' : 'unequipped';

        return [...acc, { item: itemData, product, status }];
      }, []),
    [shopState, notFilteredShopItems, getSlotType, buyProducts, items],
  );

  const { toggle, setters } = useMemo(() => {
    let keys = Object.keys(shopItems);
    if (defaultStore !== stores.ru) {
      keys = keys.filter((key) => key !== 'character');
    }

    return {
      toggle: keys.reduce((acc, key) => [...acc, { action: key, ...(toggleData[key] ?? {}) }], []),
      setters: keys.reduce((acc, key) => ({ ...acc, [key]: () => setShopState(key) }), []),
    };
  }, [shopItems]);

  return (
    <section className={classNames('shop', { shop_app: !isWeb })} ref={ref}>
      <Back />
      <div className={`shop__content`}>
        <ShopHeader setters={setters} toggle={toggle} />
        <div className={'shop__main'}>
          <Scrollbar {...ratingScrollbarSettings}>
            <ShopInfo />
            <SwitchTransition>
              <CSSTransition
                key={shopState}
                timeout={300}
                classNames={'shop__items'}
                mountOnEnter={true}
                unmountOnExit={true}
                appear={true}
              >
                <ShopItems callbacks={callbacks} necessaryItems={necessaryItems} />
              </CSSTransition>
            </SwitchTransition>
          </Scrollbar>
        </div>
      </div>
    </section>
  );
});

export default Shop;
Shop.propTypes = {};
